import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { TaxReason } from 'src/features/taxReasons/utils/types';
import { TaxReasonFormSchemaValues } from 'src/features/taxReasons/utils/formSchema';

const RESOURCE = '/subscriptions/tax-reason/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: TaxReasonFormSchemaValues): Promise<TaxReason> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateTaxReason };
